import { CourseThemeData } from '../Courses/types';

export enum ActionTypes { // eslint-disable-line no-shadow
  COURSE_APPEARANCE_SETTINGS_SET_PREVIEW = 'COURSE_APPEARANCE_SETTINGS_SET_PREVIEW',
  COURSE_APPEARANCE_SETTINGS_CLEAR_PREVIEW = 'COURSE_APPEARANCE_SETTINGS_CLEAR_PREVIEW',
}

export interface CourseAppearanceSettingsSetPreviewAction {
  type: ActionTypes.COURSE_APPEARANCE_SETTINGS_SET_PREVIEW;
  settings: CourseThemeData;
}

export interface CourseAppearanceSettingsClearPreviewAction {
  type: ActionTypes.COURSE_APPEARANCE_SETTINGS_CLEAR_PREVIEW;
}

export type CourseAppearanceSettingsAction =
  | CourseAppearanceSettingsSetPreviewAction
  | CourseAppearanceSettingsClearPreviewAction;
